var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSeven(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3047 128V126.531L20.3047 122.672C21.4453 121.531 22.0391 120.859 22.0391 119.906C22.0391 118.852 21.2031 118.188 20.1016 118.188C18.9375 118.188 18.1875 118.914 18.1953 120.062H16.2578C16.25 117.922 17.8594 116.531 20.1172 116.531C22.4297 116.531 23.9844 117.914 23.9922 119.812C23.9844 121.086 23.375 122.117 21.1484 124.219L19.1328 126.219V126.297H24.1641V128H16.3047ZM25.4922 125.891V124.266L30.3828 116.688H32.9141V124.219H34.3984V125.891H32.9141V128H30.9766V125.891H25.4922ZM27.5703 124.219H31.0078V119H30.8828L27.5703 124.141V124.219ZM40.6484 116.156L37.0078 129.703H35.2578L38.9141 116.156H40.6484ZM42.1797 128L47.0859 118.469V118.391H41.3984V116.688H49.1953V118.422L44.2891 128H42.1797ZM65.9922 115.266V125.703H64.2578V122.016H62.2578V120.578H64.2578V119.234H62.2578V117.828H64.2578V115.266H65.9922ZM54.1797 122.406C54.6719 122.406 55.2109 122.406 55.7734 122.398V117.719H54.5391V116.328H62.0547V117.719H60.8047V122.234C61.3359 122.195 61.8516 122.148 62.3516 122.094L62.4297 123.359C59.75 123.789 56.6172 123.844 54.3672 123.844L54.1797 122.406ZM56.7109 129.109V124.891H58.4609V127.703H66.3516V129.109H56.7109ZM57.4609 122.375C58.0078 122.367 58.5703 122.344 59.1328 122.32V117.719H57.4609V122.375ZM72.5703 116.25C74.8125 116.242 76.4453 117.656 76.4609 119.656C76.4453 121.664 74.8125 123.07 72.5703 123.078C70.3516 123.07 68.6875 121.664 68.6953 119.656C68.6875 117.656 70.3516 116.242 72.5703 116.25ZM68.0547 125.031C70.6016 125.031 74.125 125 77.1797 124.562L77.3203 125.828C74.1562 126.43 70.7656 126.453 68.2734 126.453L68.0547 125.031ZM70.4141 119.656C70.4062 120.836 71.3359 121.562 72.5703 121.562C73.8203 121.562 74.75 120.836 74.7578 119.656C74.75 118.484 73.8281 117.75 72.5703 117.75C71.3359 117.75 70.4062 118.484 70.4141 119.656ZM78.0234 129.406V115.266H79.7578V129.406H78.0234ZM93.6484 115.266V123.469H91.9141V120.047H89.4766V118.625H91.9141V115.266H93.6484ZM81.7891 122.062C84.0391 121.32 85.2422 119.445 85.2422 117.578V117.469H82.3047V116.062H89.9297V117.469H87.0078V117.594C87.0078 119.289 88.1484 121.039 90.3359 121.781L89.4609 123.156C87.8828 122.617 86.7656 121.539 86.1484 120.203C85.5234 121.688 84.3516 122.867 82.6797 123.422L81.7891 122.062ZM84.2578 129.219V124.078H93.6484V129.219H84.2578ZM85.9922 127.812H91.9453V125.453H85.9922V127.812ZM111.273 115.266V129.406H109.539V121.891H107.117V120.469H109.539V115.266H111.273ZM99.9141 117.906V116.5H106.305V121.672H101.68V124.641C103.781 124.633 105.469 124.562 107.367 124.219L107.508 125.641C105.406 126.008 103.516 126.086 101.086 126.094H99.9609V120.266H104.602V117.906H99.9141ZM125.117 115.266V129.406H123.398V121.75H120.523V125.984H113.805V116.359H115.555V119.875H118.82V116.359H120.523V120.328H123.398V115.266H125.117ZM115.555 124.594H118.82V121.234H115.555V124.594Z",
    fill: "#242424"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1275_5264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.022 49.0005C119.022 75.5258 97.5277 97.0205 71.0024 97.0205C44.4771 97.0205 22.9824 75.5258 22.9824 49.0005C22.9824 22.4751 44.4771 0.980469 71.0024 0.980469C97.5277 0.980469 119.022 22.4751 119.022 49.0005Z",
    fill: "url(#paint0_linear_1275_5264)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1275_5264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.6 48.9999C113.6 72.4668 94.5762 91.4905 71.1093 91.4905C47.6424 91.4905 28.6187 72.4668 28.6187 48.9999C28.6187 25.533 47.6424 6.50933 71.1093 6.50933C94.5762 6.50933 113.6 25.533 113.6 48.9999Z",
    stroke: "#98A2B3",
    strokeWidth: 2.56553
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1275_5264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.12 75.2333C70.3726 75.2333 69.6018 75.2099 68.8544 75.1398C63.0386 74.626 57.5966 72.2203 53.3224 68.273C52.575 67.5723 52.5516 66.4045 53.299 65.7038C53.9763 65.0732 55.0274 65.0732 55.7047 65.7038C59.395 69.1139 64.113 71.216 69.158 71.6597C75.908 72.2436 82.5646 69.7679 87.2826 65.0031C87.9366 64.3492 88.9643 64.3024 89.665 64.8864C90.4357 65.5403 90.4825 66.7082 89.7818 67.4322C84.8769 72.4071 78.1269 75.2333 71.12 75.2333Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5921 71.0522L51.5221 65.7503C51.4987 64.8394 52.1994 64.0686 53.1103 63.9752L58.4356 63.4847C59.3932 63.3913 60.2574 64.1153 60.3274 65.0729C60.4208 66.0305 59.6968 66.8947 58.7392 66.9648L56.6605 67.1516C55.7496 67.2451 55.0489 68.0158 55.0722 68.9267L55.0956 70.9821C55.1189 71.9397 54.3482 72.7338 53.3672 72.7572C52.4096 72.8039 51.6155 72.0331 51.5921 71.0522Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5977 33.1448C51.8269 32.4908 51.7569 31.323 52.4809 30.5989C57.9463 25.0634 65.6539 22.214 73.4316 22.8913C79.2474 23.4051 84.6894 25.8108 88.9637 29.7581C89.7111 30.4588 89.7344 31.6266 88.987 32.3273C88.3097 32.9579 87.2586 32.9579 86.5813 32.3273C82.891 28.9172 78.173 26.8152 73.128 26.3714C66.378 25.7875 59.7214 28.2633 55.0034 33.028C54.3261 33.682 53.2984 33.7287 52.5977 33.1448Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9573 32.9348C81.8639 31.9772 82.588 31.113 83.5456 31.0429L85.6243 30.8561C86.5352 30.7626 87.2359 29.9919 87.2125 29.081L87.1892 27.0256C87.1658 26.068 87.9366 25.2739 88.9176 25.2505C89.8752 25.2272 90.6693 25.9979 90.6926 26.9789L90.7627 32.2808C90.7861 33.1917 90.0854 33.9625 89.1745 34.0559L83.8492 34.523C82.8916 34.6164 82.0274 33.8924 81.9573 32.9348Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.904 54.7729C58.904 55.6371 58.2033 56.3144 57.3625 56.3144H49.8417C48.9075 56.3144 48.1367 55.5436 48.1367 54.6094C48.1367 54.1422 48.3236 53.6751 48.6739 53.3715L53.2985 49.0505C54.3962 48.0229 54.5597 47.3922 54.5597 46.8317C54.5597 45.9441 53.9758 45.4069 52.7846 45.4069C52.1307 45.4069 51.5234 45.5938 51.0096 45.9675C50.4724 46.3646 49.7717 46.4346 49.2111 46.131C48.1601 45.5471 48.0666 44.0756 49.071 43.3983C50.122 42.6509 51.5 42.2305 53.1584 42.2305C56.3348 42.2305 58.5303 43.8654 58.5303 46.4346C58.5303 47.7659 58.1566 49.0038 56.1713 50.8256L53.5554 53.2313H57.3392C58.2033 53.2313 58.904 53.9087 58.904 54.7729Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.821 53.6751H71.3071V54.4225C71.3071 55.4736 70.4663 56.3377 69.3919 56.3377C68.3408 56.3377 67.4767 55.4969 67.4767 54.4225V53.6751H62.1047C61.0303 53.6751 60.1895 52.8109 60.1895 51.7599C60.1895 51.3628 60.3062 50.9658 60.5398 50.6388L65.8651 43.2114C66.1687 42.7677 66.6825 42.5107 67.2197 42.5107C68.5744 42.5107 69.3452 44.0289 68.5978 45.1267L64.7907 50.5687H67.5934V50.0549C67.5934 49.0272 68.4109 48.2097 69.4386 48.2097C70.4663 48.2097 71.2838 49.0272 71.2838 50.0549V50.5687H71.7976C72.6618 50.5687 73.3391 51.2694 73.3391 52.1102C73.3625 52.9978 72.6618 53.6751 71.821 53.6751Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.21 39.708C82.2844 39.708 83.0551 40.7824 82.7048 41.8101L77.2861 57.2487C77.0759 57.8793 76.4686 58.2997 75.7913 58.2997C74.7169 58.2997 73.9461 57.2253 74.2965 56.1977L79.7152 40.759C79.9487 40.1284 80.5326 39.708 81.21 39.708Z",
    fill: "#98A2B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.851 44.5423C94.851 44.8226 94.8043 45.0795 94.6875 45.3364L90.4833 55.1461C90.1797 55.8702 89.479 56.3373 88.6849 56.3373C87.2835 56.3373 86.3259 54.8892 86.8864 53.6046L90.3665 45.6167H86.7463V46.0838C86.7463 46.9947 85.9989 47.7421 85.088 47.7421C84.1771 47.7421 83.4297 46.9947 83.4297 46.0838V44.1919C83.4297 43.281 84.1771 42.5336 85.088 42.5336H92.8423C93.9401 42.5103 94.851 43.4212 94.851 44.5423Z",
    fill: "#98A2B3"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1275_5264",
    x: 27.3359,
    y: 5.22656,
    width: 87.5469,
    height: 88.5731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.513106
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_5264"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1275_5264",
    x: 48.1367,
    y: 22.793,
    width: 46.7148,
    height: 53.4666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.02621
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.513106
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1275_5264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1275_5264",
    x1: 37.6824,
    y1: 11.4338,
    x2: 107.752,
    y2: 79.3805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD2D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71136,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAC1CB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1275_5264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 98,
    fill: "white",
    transform: "translate(22)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeven);
export default __webpack_public_path__ + "static/media/Seven.a1e68a5e5926799417da47bd53b79fa1.svg";
export { ForwardRef as ReactComponent };